// SEQ-217: where "Create in Dashpivot" sends the user.
//
// Variations are entered in the shared Contract Variance app ("Variation
// Database CORRECT FORM", Variations and Hire > Contract Variance), and the
// job is chosen in the form's required List field. The per-job Foreman copy
// of that app (claims_projects.dashpivot_foreman_app_id) is still read by sync
// and must keep its stored id, but it is no longer where new forms are made.
//
// This id must equal MAIN_VARIATIONS_APP_ID in
// supabase/functions/sync-variations/index.ts, the only other place it lives.
// dashpivotLinks.test.ts reads that file and fails if the two drift.
export const CONTRACT_VARIANCE_APP_ID = "695aefc668a90e228daa6e43";

// A new blank form in the Contract Variance app. Takes no project: every job
// uses the same app, so a project with no Foreman id still gets a working link.
export function dashpivotCreateVariationUrl(): string {
  return `https://dashpivot.com/apps/${CONTRACT_VARIANCE_APP_ID}/forms/active/timeline/new`;
}
